import React from 'react'
import { StyledForm } from '../signalement.styles'
import { Signalement } from '../../../api/signalement'
import { getAdresseLabel } from '../../../utils/adresse.utils'
import { IBANPlateformeResult } from '../../../api/ban-plateforme/types'

interface SignalementDeleteFormProps {
  signalement: Signalement
  onEditSignalement: (property: keyof Signalement, key?: string) => (event: string) => void
  onClose: () => void
  address: IBANPlateformeResult
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

export default function SignalementDeleteForm({
  signalement,
  onEditSignalement,
  onClose,
  address,
  onSubmit,
}: SignalementDeleteFormProps) {
  const { comment } = signalement.changesRequested

  return (
    <StyledForm onSubmit={onSubmit}>
      <h4>Demande de suppression</h4>
      <section>
        <h5>Adresse concernée</h5>
        <div>{getAdresseLabel(address)}</div>
      </section>
      <section>
        <div className='form-row'>
          <div className='fr-input-group'>
            <label className='fr-label' htmlFor='comment'>
              Raisons de la suppression*
            </label>
            <textarea
              className='fr-input'
              name='comment'
              value={comment as string}
              onChange={(event) =>
                onEditSignalement('changesRequested', 'comment')(event.target.value)
              }
              required
              placeholder='Merci de ne pas indiquer de données personnelles'
            />
          </div>
        </div>
      </section>
      <div className='form-controls'>
        <button
          className='fr-btn'
          disabled={!comment?.trim()}
          style={{ color: 'white' }}
          type='submit'
        >
          Suivant
        </button>
        <button className='fr-btn fr-btn--tertiary' type='button' onClick={onClose}>
          Annuler
        </button>
      </div>
    </StyledForm>
  )
}
